module.exports = __webpack_public_path__ + "img/pont.847a4fff.jpg";